/*
 * HAKI community page, phones only: the Chatroom as a bottom sheet (direction A, 2026-10-07).
 *
 * Below 750px the Chatroom is hidden off-screen and one bar ("Open chatroom · N messages") opens it.
 * While open it is a modal dialog: role=dialog + aria-modal, everything else on the page is inert,
 * Tab stays inside, Esc / the close button / the dimmed backdrop close it, and focus goes back to the
 * bar. At 750px and wider none of this runs and the Chatroom is the normal side panel.
 */
(function () {
  'use strict';
  var MQ = '(max-width: 749px)';

  function init(section) {
    var sheet = section.querySelector('[data-hgv2-sheet]');
    var openBtn = section.querySelector('[data-hgv2-open]');
    var closeBtn = section.querySelector('[data-hgv2-close]');
    var scrim = section.querySelector('[data-hgv2-scrim]');
    var countSrc = section.querySelector('[data-hgv2-chat-count]');
    var countDst = section.querySelector('[data-hgv2-open-count]');
    if (!sheet || !openBtn || !window.matchMedia) return;
    var mq = window.matchMedia(MQ);
    var isOpen = false, inerted = [], lastFocus = null;

    // Mirror "N messages" onto the bar, so the closed state still says how much is in there.
    function syncCount() { if (countSrc && countDst) countDst.textContent = countSrc.textContent; }
    if (countSrc && typeof MutationObserver !== 'undefined') new MutationObserver(syncCount).observe(countSrc, { childList: true, characterData: true, subtree: true });
    syncCount();

    function setDialogRole(on) {
      if (on) { sheet.setAttribute('role', 'dialog'); sheet.setAttribute('aria-modal', 'true'); }
      else { sheet.removeAttribute('role'); sheet.removeAttribute('aria-modal'); }
    }
    // Everything outside the sheet (walking up to <body>) becomes inert while it is open.
    function setInert(on) {
      if (!on) { inerted.forEach(function (el) { el.inert = false; el.removeAttribute('inert'); }); inerted = []; return; }
      var node = sheet;
      while (node && node !== document.body) {
        var parent = node.parentElement;
        if (!parent) break;
        Array.prototype.forEach.call(parent.children, function (sib) {
          if (sib === node || sib === scrim || sib.tagName === 'SCRIPT' || sib.hasAttribute('inert')) return;
          sib.inert = true; sib.setAttribute('inert', ''); inerted.push(sib);
        });
        node = parent;
      }
    }
    function focusables() {
      return Array.prototype.filter.call(sheet.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'), function (el) {
        return el.offsetWidth > 0 || el.offsetHeight > 0;
      });
    }
    function open() {
      if (isOpen || !mq.matches) return;
      isOpen = true; lastFocus = document.activeElement;
      setDialogRole(true);
      sheet.classList.add('is-open'); if (scrim) scrim.classList.add('is-open');
      openBtn.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      setInert(true);
      // Land on the close button: the first control, and the way back out.
      (closeBtn || sheet).focus({ preventScroll: true });
      var list = sheet.querySelector('[data-hgv2-chat-list]');
      if (list) list.scrollTop = list.scrollHeight;
    }
    function close() {
      if (!isOpen) return;
      isOpen = false;
      sheet.classList.remove('is-open'); if (scrim) scrim.classList.remove('is-open');
      openBtn.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      setInert(false);
      if (mq.matches) (lastFocus && lastFocus.isConnected ? lastFocus : openBtn).focus({ preventScroll: true });
    }
    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (scrim) scrim.addEventListener('click', close);
    sheet.addEventListener('keydown', function (e) {
      if (!isOpen) return;
      if (e.key === 'Escape') {
        // Let the city suggestions close first if they are open.
        var sug = sheet.querySelector('[data-hgv2-sug]');
        if (sug && !sug.hidden) return;
        e.preventDefault(); close(); return;
      }
      if (e.key !== 'Tab') return;
      var f = focusables(); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    function onMq() {
      if (!mq.matches) { close(); setDialogRole(false); }
    }
    if (mq.addEventListener) mq.addEventListener('change', onMq); else if (mq.addListener) mq.addListener(onMq);
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-hgv2]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
